export const LOGO_URL =
  "https://customer-assets-agu9un31.emergentagent.net/job_luxury-transport-hub-5/artifacts/za92nf5t_Logo%20Hi%20Resolution.png";

export function Logo({ imgClass = "h-9 w-9", textClass = "text-2xl", showText = true }) {
  return (
    <span className="flex items-center gap-2.5">
      <img
        src={LOGO_URL}
        alt="Aspen Executive Limo logo"
        className={`${imgClass} object-contain shrink-0`}
      />
      {showText && (
        <span className={`font-heading ${textClass} tracking-tight leading-none`}>
          Aspen Executive Limo
        </span>
      )}
    </span>
  );
}
